import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { FLUID_WIDGETS_STATE } from '@app/_helpers';
import { WidgetState } from '@app/app.interface';
import { WidgetViewMode } from '@app/app.structs';


@Injectable({
  providedIn: 'root'
})
export class WidgetStateService {
  mkpicMaxChartMin = new BehaviorSubject(false);
  isMaximised = new BehaviorSubject(false);
  widgetsState = FLUID_WIDGETS_STATE;
  private _fullScreenWidget = null;

  public widgetStateChange: Subject<any> = new Subject<any>();

  constructor() {
    
    this.widgetStateChange.subscribe((widgetState) => {
      this.widgetsState = widgetState;
    });
  }

  changeWidgetState(widget: WidgetState) {
    this.widgetsState[widget.widgetName] = widget.widgetState;
    /*
      * Storing data in local storage.
    */
    this.widgetStateChange.next(this.widgetsState);

    /**
     * If widget state is changed to fullscreen, _fullScreenWidget variable will store that widget name and it will be set to null
     * if same widget is toggled from full screen to any other state.
    */
    if (widget.widgetState === WidgetViewMode.FULLSCREEN) {
      this._fullScreenWidget = widget.widgetName;
    } else if (widget.widgetName === this._fullScreenWidget && (widget.widgetState as WidgetViewMode) !== WidgetViewMode.FULLSCREEN) {
      this._fullScreenWidget = null;
    }
  }

  getWidgetState() {
    return this.widgetsState;
  }

  get getFullscreenWidgetName() {
    return this._fullScreenWidget;
  }

}
